class Radios extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.current_value = this.querySelector(".radios--option-current")),
        (this.current_description = this.querySelector(".variant_description")),
        (this.inputs = this.querySelectorAll("input")),
        (this.is_swatches = "true" === this.getAttribute("data-is-swatches")),
            this.preventFormSubmitOnEnter(),
            this.is_swatches && (theme.utils.setSwatchColors(this.inputs), this.current_value) && this.updateLabelOnChange();
    }
    disconnectedCallback() {
        this.inputs.off("keydown.Radios change.Radios");
    }
    preventFormSubmitOnEnter() {
        this.inputs.on("keydown.Radios", (t) => {
            "Enter" === t.key && t.preventDefault();
        });
    }
    updateLabelOnChange() {
        this.inputs.on("change.Radios", (t) => {
            (this.current_value.textContent = t.target.value), (this.current_description.textContent = t.target.getAttribute("data-shade-description"));
            
            let currentValue = t.target.value;
            const show = 'show';
            // bbb

           //alert(currentValue);
          
            // const elements = document.querySelectorAll('.featured-image');
            // elements.forEach(element => {
            //     const dataAttribute = element.getAttribute('data-variant-name');
            //     element.classList.remove(show);
            //     if (dataAttribute == currentValue){
            //         element.classList.add(show);
            //     }
            //     // alert(dataAttribute);
            // });

const elements = document.querySelectorAll(".radios--value-button");

elements.forEach((button) => {
    const childElements = button.querySelectorAll('.featured-image');

    childElements.forEach((child) => {

        const dataAttribute = child.getAttribute('data-variant-name');
        child.classList.remove(show);

        if (dataAttribute == currentValue){
            child.classList.add(show);
        }
    });

});

elements.forEach((button) => {
    const childElements = button.querySelectorAll('.featured-image.show');
    const unavailableImage = button.querySelector('.featured-image.unavailable');
    const size = childElements.length;
    if(size == 0){
        unavailableImage.style.display = 'block';
    }else{
        unavailableImage.style.display = 'none';
    }

});

        });
    }
}
customElements.define("radios-root", Radios);
